import React from "react";
import "./index.css";
import { ADDRESSES } from "./constants";

function AddressSection() {
  return (
    <div className="addressDetails">
      <div className="container">
        <div className="addressRow">
          <h2 className="titleText aosAnim boldText ltr">Find us here</h2>
          <div className="addressBoxWrap aosAnim ltr">
            {ADDRESSES.map(({ name, address, image, mapUrl, id }) => (
              <div className="eachAddressBox" key={name}>
                <div className="imgBox">
                  <img loading="lazy" src={image} alt={name} />
                </div>
                <div className="contactBox">
                  <h4>{name}</h4>
                  <p>{address}</p>
                </div>
                <div className="btnBox">
                  <a
                    href={mapUrl}
                    className="npButton"
                    target="_blank"
                    rel="noreferrer"
                    id={id}
                  >
                    View on Map
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddressSection;
